import { BaseAPI } from './base';
import type { BaseResponse, ListResponse, PaginationRequest } from '../../types/base.dto';

// 主体接口定义
export interface MainBody {
  id: string;
  name: string;
  code?: string;
  description?: string;
  status?: number;
  shop_count?: number;
  created_at?: string;
  updated_at?: string;
  [key: string]: any;
}

// 主体列表查询参数
export interface MainBodyListParams extends PaginationRequest {
  name?: string;
  status?: number;
  code?: string;
}

// 主体创建参数
export interface MainBodyCreateParams {
  name: string;
  code?: string;
  description?: string;
  status?: number;
}

// 主体更新参数
export interface MainBodyUpdateParams {
  name?: string;
  code?: string;
  description?: string;
  status?: number;
}

/**
 * 主体API服务类
 * 继承BaseAPI，提供主体相关的CRUD操作
 */
export class MainBodyAPI extends BaseAPI<MainBody> {
  constructor() {
    super('/main-bodies');
  }
}

// 创建主体API实例
export const mainBodyApi = new MainBodyAPI();

export default mainBodyApi;